import { r as registerInstance, h } from './index-4ec8feae.js';

const somListHeaderCss = ".list-header.sc-som-list-header{font-weight:700;font-variation-settings:\"wght\" 700;color:#323e43;padding:0.5rem 1.5rem;font-size:1rem;line-height:1.5rem;border-radius:0;margin-top:1.5rem}";

let SomListHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "list-header" }, h("slot", null)));
  }
};
SomListHeader.style = somListHeaderCss;

export { SomListHeader as som_list_header };
